import type { TargetingCustomOptions } from '@openx/types/targeting/targeting.ts';
import { createContext, type ReactNode, useContext, useState } from 'react';

export type CustomOptionsContextValue<T> = TargetingCustomOptions<T> | undefined;

type CustomOptionsProviderType<T> = {
  children: ReactNode;
  value?: TargetingCustomOptions<T>;
};

export const CustomOptionsContext = createContext<CustomOptionsContextValue<unknown> | undefined>(undefined);

export function CustomOptionsProvider<T>({ children, value }: CustomOptionsProviderType<T>) {
  const [customOptions] = useState<CustomOptionsContextValue<T> | undefined>(value);

  return <CustomOptionsContext.Provider value={customOptions}>{children}</CustomOptionsContext.Provider>;
}

export function useCustomOptionsContext<T>() {
  return useContext(CustomOptionsContext) as CustomOptionsContextValue<T>;
}
